import React from "react";
import { createTheme, ThemeProvider } from "@material-ui/core";

const theme = createTheme(
  /**
   * @see https://material-ui.com/customization/themes/#theme-configuration-variables
   */
  {
    // direction: "rtl",
    typography: {
      fontFamily: ["Poppins"].join(","),
      h5: {
        fontWeight: 600,
      },
      subtitle1: {
        fontWeight: 500,
        fontSize: '1.125rem',
      }
    },

    palette: {
      primary: {
        light: "#FFE2E5",
        main: "#F64E60",
        dark: "#EE2D41",
        contrastText: "#fff"
      },
      secondary: {
        light: "#443E84",
        main: "#140F4E",
        dark: "#040036",
        contrastText: "#fff"
      },
      text: {
        primary: "rgba(0,0,0,0.87)",
        secondary: "rgba(0,0,0,0.6)",
        disabled: "rgba(0,0,0,0.36)"
      },
    },

    /**
     * @see https://material-ui.com/customization/globals/#default-props
     */
    props: {
      // Name of the component ⚛️
      MuiButtonBase: {
        // The properties to apply
        disableRipple: false // No more ripple, on the whole application 💣!
      },

      // Set default elevation to 1 for popovers.
      MuiPopover: {
        elevation: 1
      },
    },
    overrides: {
      MuiOutlinedInput: {
        root: {
          "&:hover fieldset": {
            borderColor: "#F64E60 !important"
          },
        }
      },
    }
  }
);

export function MaterialThemeProvider(props) {
  const { children } = props;

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
